import { ItinerarySegment } from './itinerary-segment';

export class RepositioningItineraryModel {
  flightRate?: number;
  landingFee?: number;
  flexibility: number;
  repositioningPrice?: number;
  densityFeePrice?: number;
  landingFeePrice?: number;
  segments?: Array<ItinerarySegment>;
}
